import { parseISO } from 'date-fns';
import { format } from 'date-fns-tz';
import {
  LOCAL_DATETIME_FORMAT,
  LOCAL_TIMEZONE,
} from 'lib_ts/enums/datetime.enums';
import { DictOf } from 'lib_ts/interfaces/common/i-dictionary';
import { DEFAULT_PITCH, IPitch } from 'lib_ts/interfaces/pitches';
import { clone } from 'lodash';

// all dates in the ShotHistory section use the format below
export const formatDate = (date?: string) =>
  date
    ? format(parseISO(date), LOCAL_DATETIME_FORMAT, {
        timeZone: LOCAL_TIMEZONE,
      })
    : '';

export const getPitch = (pitchDict: DictOf<IPitch>, pitchId?: string): IPitch =>
  pitchDict[pitchId ?? 'no id'] ?? clone(DEFAULT_PITCH);
